import { FC, ReactNode } from "react";
import {
  ErrorContentWrapper,
  ErrorHeader,
  Wrapper,
  Button,
  ErrorBody,
} from "./ErrorTemplate.styles";
import ErrorContactDetails from "../../components/ErrorContactDetails/ErrorContactDetails";

type ErrorTemplateProps = {
  header: string;
  description?: string;
  button?: { buttonText: string; onClick: () => void };
  children?: ReactNode;
  islayoutUsed?: boolean;
  showContact?: boolean;
};

const ErrorTemplate: FC<ErrorTemplateProps> = ({
  header,
  description,
  button,
  children,
  islayoutUsed = false,
  showContact = false,
}) => {
  return (
    <Wrapper $islayoutUsed={islayoutUsed}>
      <ErrorContentWrapper>
        <ErrorHeader>{header}</ErrorHeader>

        <ErrorBody>
          {description && <p>{description}</p>}
          {children}
          {showContact && <ErrorContactDetails />}
        </ErrorBody>

        {button && (
          <Button onClick={button.onClick}>{button.buttonText}</Button>
        )}
      </ErrorContentWrapper>
    </Wrapper>
  );
};

export default ErrorTemplate;
